import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  ClassLayer  from '../components/class/ClassLayer'

export const ClassPage = () => {
  return (
    <MasterLayout>
        <ClassLayer/>
        </MasterLayout>
  )
}
